// @flow

import React from 'react';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import type {ILocalesTransformers} from '../../utils/locales';
import {SiteCard} from '../SiteCard/SiteCard';
import withLocales from '../../HOCs/withLocales';
import {SlideContainer} from './StyledCarouselSiteCards';

type CarouselSiteCardsProps = ILocalesTransformers & {
    sitesToMap: Object
}

export const CarouselSiteCards = withLocales((props: CarouselSiteCardsProps): any => {
    const {sitesToMap} = props;
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = sitesToMap.slice(0, 5).length;

    const handleNext = () => {
        setActiveStep((prevActiveStep: number): any => prevActiveStep + 1);
    };

    const handleBack = (): any => {
        setActiveStep((prevActiveStep: number): any => prevActiveStep - 1);
    };

    const handleStepChange = (step: number) => {
        setActiveStep(step);
    };

    return (
        <div style={{maxWidth: 400, flexGrow: 1}}>
            <SwipeableViews
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
            >
                { sitesToMap.slice(0, 5).map((site: Object, index: number): any => (
                    <SlideContainer key={site.name}>
                        {Math.abs(activeStep - index) <= 2 ? (
                            <SiteCard
                                imgPath={site.image}
                                iconPath={site.icon}
                                title={site.name}
                                subtitle={site.reviews}
                                rating={site.rating}
                                starsPath={site.stars}/>
                        ) : null}
                    </SlideContainer>
                ))}
            </SwipeableViews>
            <MobileStepper
                steps={maxSteps}
                position="static"
                variant="dots"
                activeStep={activeStep}
                nextButton={
                    <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                        <KeyboardArrowRight/>
                    </Button>
                }
                backButton={
                    <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                        <KeyboardArrowLeft/>
                    </Button>
                }
            />
        </div>
    );
});

